import { useEffect, useState } from 'react';
import { Typography, Box, Card, CardContent, CardHeader, Button, Link, Grid, CircularProgress } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { AppSection } from '../../../components/forms';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { useWallet, useConnection } from '@solana/wallet-adapter-react';
import { useAppStore } from '../../../store/AppStore';
import TwitterIcon from '@mui/icons-material/Twitter';
import axios from 'axios';
import { usePendingBetsContext } from '../../../context/PendingBetsContext';
import { toast } from 'react-toastify';
import ErrorToast from '../../../components/ToastComponents/ErrorToast';
import {genName} from "./nameGen.js";
import {genTx} from "./buildTx.js";
import { TldParser } from "@onsol/tldparser";
import * as buffer from "buffer";
window.Buffer = buffer.Buffer;


const useStyles = makeStyles((theme) => ({
  wallet: {
    // color: 'black',
    backgroundColor: theme.palette.primary.main,
    // my: 2,
    // display: 'block'
  },
  walletInput: {
    border: 'none',
    width: '4rem',
  },
}));

/**
 * Renders demo section for Tags and TagCloud
 */
const BetSlipSection = ({ useTagCloud = false }) => {
  const classes = useStyles();
  const wallet = useWallet();
  const { connection } = useConnection();
  const [solBalance, setSolBalance] = useState(0);
  const [usdcATA, setUsdcATA] = useState();
  const [domain, setDomain] = useState("");
  const [usdcBalance, setUSDCBalance] = useState(0);
  const [points, setPoints] = useState(0);
  const [address, setAddress] = useState('');
  const [state, dispatch] = useAppStore();
  const [stake, setStake] = useState(0);
  const [odds, setOdds] = useState(0);
  const [realOdds, setRealOdds] = useState(0);
  const [totalRisk, setTotalRisk] = useState(0);
  const [potentialReturn, setPotentialReturn] = useState(0);
  const [potentialProfit, setPotentialProfit] = useState(0);
  const [effectiveOdds, setEffectiveOdds] = useState(0);
  const [hash, setHash] = useState('');
  const [hashLink, setHashLink] = useState('');
  const [twitterDisplay, setTwitterDisplay] = useState(false);
  const [loading, setLoading] = useState();
  const { refreshData, placingBet, updatingAccs, addBet } = usePendingBetsContext();

  var solanaWeb3 = require('@solana/web3.js');
  var mintStr = process.env.REACT_APP_WALLET_ADAPTER_NETWORK == 'dev' ? 
    "3zPjW4EMwJzd6yjriNk66X88aJqjgKcXWL8Cfb2Ydyfm" : 
    'AKEWE7Bgh87GPp171b4cJPSSZfmZwQ3KaqYqXoKLNAEE';

  useEffect(() => {
    if (wallet.publicKey) {
      setAddress(wallet.publicKey.toBase58());
      getUSDCBalance();
      getSolBalance();
      getPoints(wallet.publicKey);
      getDomain(wallet.publicKey);
    }
  }, [wallet.publicKey, connection]);

  async function getSolBalance(){
    setSolBalance(await connection.getBalance(wallet.publicKey) / 1000000000);
  }

  async function getUSDCBalance() {
    let payload = {
      "jsonrpc": "2.0",
      "id": Math.round(Math.random() * 100),
      "method": "getTokenAccountsByOwner",
      "params": [
          wallet.publicKey.toBase58(),
          {
              "mint": mintStr
          },
          {
              "encoding": "jsonParsed"
          }
      ]
    };
    let resp = await axios.post(process.env.REACT_APP_RPC_URL, payload);
    setUsdcATA(new solanaWeb3.PublicKey(resp?.data?.result?.value[0]?.pubkey));
    setUSDCBalance(resp?.data?.result?.value[0]?.account?.data?.parsed?.info?.tokenAmount?.uiAmount);
  }

  async function getPoints(pubkey) {
    const addr = pubkey.toString()
    const pointsApiResp = await axios.get(`https://api.purebet.io/purebet/points-api?user=${addr}`)
    // console.log(pointsApiResp)
    const points = pointsApiResp.data
    setPoints(points)
  }

  async function getDomain(pubkey){
    const parser = new TldParser(connection);
    // get all owned domains from a TLD
    const ownedDomainsFromTld = await parser.getParsedAllUserDomainsFromTld(pubkey, "turbo");
    if(ownedDomainsFromTld.length){
      setDomain(ownedDomainsFromTld[0].domain)
    }
  }

  const handleClearBetSlip = () => {
    dispatch({
      type: 'CLEAR_BET_SLIP',
      odd: undefined,
    });
    setStake(0);
    setOdds(0);
    setRealOdds(0);
    setTotalRisk(0);
    setPotentialProfit(0);
    setPotentialReturn(0);
    setEffectiveOdds(0);
    setHash('');
    setHashLink('');
    setTwitterDisplay(false);
  };

  function lilEndInt(bytes){
    let output = 0;
    for(let pow = 0; pow < bytes.length; pow++){
        output = output + bytes[pow] * 256**pow;
    }
    return output;
  }
  
  function isBlankWallet(bytes){
    return new solanaWeb3.PublicKey(bytes).toBase58() == "11111111111111111111111111111111";
  }

  useEffect(() => {
    if (state.selectedOdd) {
      setOdds(
        state.layBetSlipStyle ? 
          state.selectedOdd.back_lay == "lay" ?
            (state.selectedOdd.odds / (state.selectedOdd.odds - 1) ).toFixed(2)
            : state.selectedOdd.odds 
          : state.selectedOdd.odds
      );
      setRealOdds(
        state.selectedOdd.odds
      )
    }
  }, [state]);

  useEffect(() => {
    if (state.selectedOdd && stake && odds) {
      if (state.selectedOdd.back_lay == 'lay') {
        if (state.layBetSlipStyle) {
          setTotalRisk((stake * (odds - 1)).toFixed(2));
          setPotentialReturn((stake * odds).toFixed(2));
          setPotentialProfit(stake.toFixed(2));
          setEffectiveOdds((odds / (odds - 1)).toFixed(2));
        } else {
          setTotalRisk(stake);
          setPotentialReturn((stake * odds).toFixed(2));
          setPotentialProfit((stake * odds - stake).toFixed(2));
          setEffectiveOdds((1 / (odds - 1) + 1).toFixed(2));
        }
      } else {
        setTotalRisk(stake);
        setPotentialReturn((stake * odds).toFixed(2));
        setPotentialProfit((stake * odds - stake).toFixed(2));
      }
    }
  }, [stake, odds]);

  const handleStakeChange = (event) => {
    setStake(event.target.value);
  };

  const handleOddsChange = (event) => {
    setOdds(event.target.value);
    setRealOdds(state.layBetSlipStyle&&state.selectedOdd.back_lay=="lay" ? event.target.value/(event.target.value-1) : event.target.value );
  };

  const handlePlaceBet = () => {
    setLoading(true);
    placingBet(false); //this false means that "placingBet is done" is a false statement
    let subscriptionId;
    let runRefresh = true; // refresh should run if there was a partial match from pbmm, or if there was no match at all from pbmm
    placeBet(
      {
        sport: state.selectedOdd.sport,
        league: state.selectedOdd.league,
        event: state.selectedOdd.eventId,
        period: state.selectedOdd.period,
        mkt: state.selectedOdd.mkt,
        player: state.selectedOdd.player
      },
      {
        userStake: totalRisk,
        side: state.selectedOdd.side,
        odds: realOdds,
        isLay: state.selectedOdd.back_lay  == "lay" //now sorted here but not downstream
      },
      {
        bettor: wallet.publicKey,
        usdcATA: usdcATA
      },
      {
        selectionName: state.selectedOdd.selectionName,
        eventName: state.selectedOdd.event
      },
      connection
    ).then((result) => {
      // result is an object with attrs showNow and listen
      // showNow --> [array of {odds, stake, acc}]
      // listen --> base58 pubkey str of the acc to listen for
      // loop through showNow and call addBet() on them
      // set a listener for listen, and it will fill in timestamp, odds, stake, matched, potentialReturn from payload. Event, team, isLay, eventStart is all from closure? maybe make a class but not necessary
      // set a setTimeout to clear the listener and call refreshData() in 60 seconds
      
      console.log(result);
      //send a dispatch call to edit the appropriate ob
      dispatch({
        type: "justbet",
        odds: odds,
        stake: totalRisk
      });
      let isLay = state.selectedOdd.back_lay == 'lay';
      let bet = isLay ? state.selectedOdd.team + " does not win" : state.selectedOdd.team; //this will show soccer back bets as HOME instead of HOME wins, not a big deal
      for(let rawBet of result.showNow){
        let betObj = { // in the future correct this but leave it for now because no user to user or monaco bets will be happening
          placedAt: Date.now() / 1000,
          bettorOdds: rawBet.odds,
          bettorStake: rawBet.liquidity,
          matched: true, // pb user to user matches instantly, monaco will open up crank so that will match instantly too in the future
          event: state.selectedOdd.event,
          team: bet,
          isLay: isLay,
          acc: rawBet.acc, 
          potentialReturn: Math.round(rawBet.odds * rawBet.liquiidty * 100) / 100,
          eventStart: state.selectedOdd.startDate
        };
        addBet(betObj);
      }
      if(result.listen != null){
        subscriptionId = connection.onAccountChange(
          new solanaWeb3.PublicKey(result.listen), 
          function(accInfo, contextIgnored){
            let accData = accInfo.data;
            console.log("websocket message", accData);
            if(isBlankWallet(accData.slice(36, 68)) || isBlankWallet(accData.slice(68, 100))){
              return;
            }
            //odds, stake, , potentialReturn, timestamp
            //matched will always be true if this is running
            let side = new solanaWeb3.PublicKey(accData.slice(36, 68)).toBase58() == wallet.publicKey.toBase58() ? 0 : 1;
            let side0Stake = lilEndInt(accData.slice(20, 28)) / 1000000;
            let side1Stake = lilEndInt(accData.slice(28, 36)) / 1000000;
            let stake = side == 0 ? side0Stake : side1Stake
            let potentialReturn = side0Stake + side1Stake
            let betObj = {
              placedAt: lilEndInt(accData.slice(133, 141)),
              bettorOdds: potentialReturn / stake,
              bettorStake: stake,
              isMatched: true, // if this account has changed, and the partial match situation is handled above, then it must be matched
              event: state.selectedOdd.event,
              description: bet,
              isLay: isLay,
              betAddr: result.listen, 
              potentialReturn: potentialReturn,
              eventStart: state.selectedOdd.startDate,
              isMonacoDirect: false,
              bettorSide: side,
              period: state.selectedOdd.period,
              sport: state.selectedOdd.sport,
              mkt: state.selectedOdd.mkt, 
              league: state.selectedOdd.league,
              eventId: state.selectedOdd.eventId
            };
            addBet(betObj);
            runRefresh = false; // acccount subscription succesfully did all refreshing
          }
        );
        console.log(subscriptionId);
      }
      else{
        runRefresh = false; //no aggregated bets means all bets were refreshed, no need to refresh
      }
      setTimeout(
        function(){
          if(result.listen != null){
            connection.removeAccountChangeListener(subscriptionId);
          }
          if(runRefresh){
            refreshData(); // only if there was an issue with the subscription
          }
        },
        60000
      );    
    }).finally(() => { 
      setLoading(false); 
      placingBet(true); // true means that "placing the bet is done" is a true statement
    });
  };

  async function placeBet(idObj, betInfo, addrs, fixtures, connection) {
    console.log(fixtures)
    let output = {showNow: [], listen: null};
    let transaction;
    // if(usdcBalance == 0){
    //   //free bet or
    // } 
    // else if(solBalance < 0.000018792){
    //   // sol free bet, call betBuilder lambda. betBuilder lambda needs to return the proper output.showNow list
    //   let payload = {idObj, betInfo, fixtures};
    //   payload.addrs = {
    //     bettor: addrs.bettor.toBase58(),
    //     usdcATA: addrs.usdcATA.toBase58()
    //   }
    //   let txResp = await axios.post("https://muj8auyny5.execute-api.ap-northeast-1.amazonaws.com/default/betBuilderv2?type=solFree", payload);
    //   transaction = solanaWeb3.Transaction.from(txResp.data.tx);
    //   output.listen = txResp.data.listen;
    // }
    // else{
      //this also needs to handle pb matching a market maker, monaco, aver. That info will come from state.selectedOdd and be cut off depending on which liquidity is used up. stake will be deducted 
      let txResp = await genTx(idObj, betInfo, addrs, fixtures, connection);
      transaction = txResp.tx;
      output.listen = txResp.listen;
    // } 
    
    //send total trasnaction
    try {
      
      const {
        context: { slot: minContextSlot },
        value: { blockhash, lastValidBlockHeight },
      } = await connection.getLatestBlockhashAndContext();
      
      const signature = await wallet.sendTransaction(transaction, connection, {minContextSlot}); 
      //await connection.confirmTransaction({ blockhash, lastValidBlockHeight, signature });
      await connection.confirmTransaction({ signature });
      setHash(signature);
      setHashLink(
        'https://eclipsescan.xyz/tx/' +
          signature +
          (process.env.REACT_APP_WALLET_ADAPTER_NETWORK == 'dev' ? '?cluster=devnet' : '')
      );
      //set the twitter link
      setTwitterDisplay(true);
      toast.info(
        <>
          <Typography variant="h6">Bet request received! We are now working on placing your bet.</Typography>
          <Typography variant="body1">Please be patient and do not cancel your bet for 3 minutes.</Typography>
        </>,
        { autoClose: 20000 }
      );
    } catch (err) {
      console.error(err);
      toast.error(<ErrorToast title="Error while placing bet" message={err.message} error={err} />);
    }
    return output;
  }

  function twitterPost(stake, outcome, event, isLay) {
    var tweetLink = 'https://twitter.com/intent/tweet?text=';
    var tweetText = 'I just bet ';
    tweetText += stake;
    tweetText += ' USDC on ';
    tweetText += outcome;
    if (isLay) {
      tweetText += ' not to win';
    }
    tweetText += ' in ';
    tweetText += event;
    tweetText +=
      ' at @Purebet_io. You can do the same at https://eclipse.purebet.io ! No sign up needed, just connect your wallet and bet 😇';
    tweetText = tweetText.replace(' ', '%20');
    tweetLink += tweetText;
    window.open(tweetLink, '', 'width=500, height=500');
  }

  const handleTwitterPost = () => {
    twitterPost(stake, state.selectedOdd.team, state.selectedOdd.event, state.selectedOdd.side.toLowerCase() == 'lay');
  };
  // console.log(state.selectedOdd, state.layBetSlipStyle)
  return (
    <AppSection
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>Bet slip</span>
          <a href={`https://www.orca.so/?chainId=eclipse&tokenIn=So11111111111111111111111111111111111111112&tokenOut=AKEWE7Bgh87GPp171b4cJPSSZfmZwQ3KaqYqXoKLNAEE`} target="_blank" style={{ textDecoration: 'none' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography color="secondary" fontWeight="bold">
                Get USDC{' '}
              </Typography>
              <img src="/img/usdc-coin-icon.png" width="28" style={{ marginLeft: '4px' }} alt="USDC icon" />
            </div>
          </a>
        </div>
      }
      outline="outlined"
    >
      {wallet.publicKey && connection ? (
        state.betState == 0 ? (
          <Card variant="outlined" sx={{ marginTop: 2, backgroundColor: 'white', color: 'black' }}>
            <CardContent>
              <Typography sx={{ fontWeight: 'bold' }}>You are connected with the following wallet address:</Typography>
              <Typography mt={1} sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'pre-line'}}>
                {
                `Nickname: ${genName(address)}
                Address: ${address.slice(0,4)}..${address.slice(address.length-4, address.length)}  ${domain}`
                }
              <Typography sx={{ fontWeight: 'bold' }}>
                Purebet Points:
              </Typography> 
              <Typography>{
                `Season 1 - ${points[0]}
                Season 2 - ${points[1]}
                Total - ${points[2]}`
              }</Typography>             
              </Typography>   
              <Typography variant="h6" mt={1}>
                Your wallet balance is:
              </Typography>
              <Typography sx={{ fontSize: '1.2rem', padding: 1 }}>{usdcBalance} USDC</Typography>
              <Typography sx={{ fontSize: '1.2rem', padding: 1 }}>{solBalance} ETH</Typography>
              {/* <Typography variant="body2">You can obtain more USDC by funding your wallet from an exchange, buying USDC with your bank card inside Phantom wallet, or swapping assets here with 0% fees*:</Typography> */}
              {/* <Box component="div" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 2, marginBottom: 2 }}>
              <Box component="div" sx={{ display: 'flex', alignItems: 'center', border: '1px solid black', padding: 1 }}>
                <Box component="img" sx={{ height: 25 }} alt="token logo" src="/img/tokens/sol.png" />
                <ArrowDownward />
                <input type="number" placeholder="0.000" className={classes.walletInput} />
              </Box>
              <Box sx={{ padding: 1 }}><ArrowForward /></Box>
              <Box component="div" sx={{ display: 'flex', alignItems: 'center', border: '1px solid black', padding: 1 }}>
                <Box component="img" sx={{ height: 25 }} alt="token logo" src="/img/tokens/usdc.png" />
                <ArrowDownward />
                <input type="number" placeholder="0.000" className={classes.walletInput} />
              </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button variant="contained">Swap assets</Button>
            </Box> */}
              {/* <Typography variant="body2" sx={{ marginTop: 1 }}>You can obtain more USDC by funding your wallet from an exchange, buying USDC with your bank card inside Phantom wallet, or swapping assets here with 0% fees*:</Typography> */}
            </CardContent>
          </Card>
        ) : (
          <Card variant="outlined" sx={{ marginTop: 2, backgroundColor: 'white', color: 'black' }}>
            <CardHeader
              title={
                (state.selectedOdd.back_lay == 'lay' ? 'LAY' : 'BACK') +
                ' bet: Betting on this selection ' +
                (state.selectedOdd.back_lay == 'lay' ? 'NOT to WIN' : 'to win')
              }
              disableTypography={true}
              sx={{
                backgroundColor: state.selectedOdd.back_lay == 'lay' ? '#B11A10': '#086912',
                color: 'white',
                fontSize: '1rem',
              }}
            />
            <CardContent>
              <Typography sx={{ fontWeight: 'bold' }}>{state.selectedOdd.event}</Typography>
              <Typography>
                {state.selectedOdd.market_title} - {state.selectedOdd.selectionName}
              </Typography>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  alignItems: 'start',
                  justifyContent: 'space-evenly',
                  marginTop: 2,
                  marginBottom: 1,
                }}
              >
                <Box component="div" sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Box component="span" sx={{ textAlign: 'center' }}>
                    {state.selectedOdd.back_lay == 'lay' ? state.layBetSlipStyle ? "Backer's stake" : 'Risk' : 'Risk' }
                  </Box>
                  <Box
                    component="div"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: '1px solid black',
                      padding: 1,
                      minWidth: '7rem',
                    }}
                  >
                    {state.betState == 1 ? (
                      <input
                        type="number"
                        placeholder="0.00"
                        className={classes.walletInput}
                        value={stake}
                        onChange={handleStakeChange}
                      />
                    ) : (
                      <Box component="span" sx={{ fontSize: '0.7rem' }}>
                        {stake}
                      </Box>
                    )}
                    <Box component="span" sx={{ fontSize: '0.7rem' }}>
                      USDC
                    </Box>
                  </Box>
                </Box>
                <Box component="div" sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Box component="span" sx={{ textAlign: 'center' }}>
                  {state.selectedOdd.back_lay == 'lay' ? state.layBetSlipStyle ? "Backer's odds" : 'Your odds' : 'Odds' }
                  </Box>
                  <Box
                    component="div"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: '1px solid black',
                      padding: 1,
                      minWidth: '7rem',
                    }}
                  >
                    {state.betState == 1 ? (
                      <input
                        type="number"
                        placeholder="0.00"
                        className={classes.walletInput}
                        value={odds}
                        onChange={handleOddsChange}
                      />
                    ) : (
                      <Box component="span" sx={{ fontSize: '0.7rem' }}>
                        {odds}
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  alignItems: 'start',
                  justifyContent: 'space-between',
                  marginBottom: 1,
                  fontSize: '0.8rem',
                }}
              >
                <Box component="div" sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Box component="span">
                    <b>Total Risk:</b> {totalRisk} USDC
                  </Box>
                  {state.selectedOdd.back_lay == 'lay' && (
                    <Box component="span">
                      <b>{state.layBetSlipStyle? "Effective odds:":"Backer's odds:"}</b> {effectiveOdds}
                    </Box>
                  )}
                </Box>

                <Box component="div" sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Box component="span">
                    <b>Potential Return:</b> {potentialReturn} USDC
                  </Box>
                  <Box component="span">
                    <b>Potential Profit:</b> {potentialProfit} USDC
                  </Box>
                </Box>
              </Box>
              <Grid container justifyContent="center" alignItems="center" flexDirection="column-reverse">
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    sx={{
                      minHeight: '3rem',
                      fontSize: '0.8rem',
                      backgroundColor: 'red',
                      lineHeight: '1rem',
                      '&:hover': {
                        backgroundColor: '#d10f0f',
                      },
                      color: 'white',
                      minWidth: '15ch',
                      paddingX: '1.2rem',
                    }}
                    onClick={handleClearBetSlip}
                  >
                    Clear bet slip
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  {state.betState == 1 && twitterDisplay == false ? (
                    <Button
                      disabled={Boolean(loading)}
                      variant="contained"
                      sx={{
                        mb: '8px',
                        minHeight: '3rem',
                        fontSize: '1.2rem',
                        color: 'white',
                      }}
                      onClick={handlePlaceBet}
                    >
                      <Box sx={{ display: 'flex' }}>
                        {Boolean(loading) ? <CircularProgress /> : null}
                        {!Boolean(loading) ? 'Place Bet' : null}
                      </Box>
                    </Button>
                  ) : (
                    <>
                      <Box
                        component="div"
                        sx={{
                          backgroundColor: '#60E055',
                          color: 'black',
                          marginBottom: '1rem',
                          minHeight: '3rem',
                          fontSize: '1rem',
                          textAlign: 'center',
                          borderRadius: '4px',
                          lineHeight: '3rem',
                          paddingX: '1rem',
                          minWidth: '15ch',
                        }}
                      >
                        Order Placed
                      </Box>
                      <Button
                        variant="contained"
                        sx={{
                          marginBottom: '1rem',
                          minHeight: '3rem',
                          fontSize: '0.6rem',
                          backgroundColor: '#1DA1F2',
                          '&:hover': {
                            backgroundColor: '#1685c9',
                          },
                          color: 'white',
                          minWidth: '15ch',
                          paddingX: '1rem',
                        }}
                        onClick={handleTwitterPost}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'stretch',
                            minWidth: '15ch',
                            paddingX: '1rem',
                          }}
                        >
                          <Box component="span" fontSize={'0.8rem'}>
                            Share
                          </Box>
                          <TwitterIcon sx={{ color: 'white', ml: '8px' }} />
                        </Box>
                      </Button>
                    </>
                  )}
                </Grid>
              </Grid>
              <Typography variant="body2" sx={{ marginTop: 1 }}>
                To finish placing your order, confirm the transaction in your wallet. 
                Your transaction confirmation will appear here after a few seconds:
              </Typography>
              {hash && (
                <Link href={hashLink} target="_blank" underline="none">
                  <Typography mt={1} sx={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
                    {hash}
                  </Typography>
                </Link>
              )}
              <Typography variant="body2" sx={{ marginTop: 1 }}>
                Do NOT leave or refresh the page until the transaction hash appears or your order may not match. On rare
                occasions, orders cannot be fulfilled immediately. We are happy to help you with any issues in our Discord server.
                Check the status of your order in your pending bets below. 
              </Typography>
            </CardContent>
          </Card>
        )
      ) : (
        <>
          <p>Connect your Eclipse blockchain wallet to place a bet.</p>
          <Box
            component="div"
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <WalletMultiButton className={classes.wallet}/>
          </Box>
          <Typography variant="caption">
            You must connect an Eclipse wallet. We recommend <a href='https://backpack.app/downloadd' target="_blank" rel="noopener noreferrer" style={{ color: '#23B3FF'}}>Backpack</a> or <a href='https://nightly.app/download' target="_blank" rel="noopener noreferrer" style={{ color: '#23B3FF'}}>Nightly</a>. 
            Connecting Phantom or Solflare or any other wallet which does not currently support Eclipse will result in errors.
            If you have any issues with this website, we are ready to help you in our Discord server. 
          </Typography>
        </>
      )}
    </AppSection>
  );
};

export default BetSlipSection
